import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { OrderPlanningToolPanel } from "../OrderPlanningToolPanel";
import { Button, SelectionMode, SlideoutDecorator } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { OrderPlanningOrders } from "../opsmgmt/OrderPlanningOrders";
import { OrderPlanningEquipment } from "../opsmgmt/OrderPlanningEquipment";
import { OrderPlanningTimeline } from "../timeline/OrderPlanningTimeline";
import { ModelRow } from "@mcleod/core";

export class RowActionFindNear extends OrderPlanningRowAction {
    public findNearOn:boolean = false;

    get findNearOnColor() {
        return "success";
    }

    override getButton(): Button {
        return this.toolPanel.buttonFindNear;
    }

    override getButtonId(): string {
        return "buttonFindNear";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["manifest_hold", "movement_id", "origin_latitude", "origin_longitude", "origin_city",
            "origin_state", "origin_zip",];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];
        if (modelRow.getBoolean("manifest_hold", false)) {
            this.addReason(reasonMap, "manifest_on_hold", "Cannot FindNear to a manifest on hold.");
        }
    }

    override async execute(props: PlanningTableRowActionProps) {
        await this.applyFindNear(!this.findNearOn);
    }

    get afterSlideout() {
        return (decorator: SlideoutDecorator) => {
            let toolPanel: OrderPlanningToolPanel;
            if (this.toolPanel.actionsLayout.getParentLayout() instanceof OrderPlanningOrders) {
                toolPanel = this.toolPanel;
            } else if (this.toolPanel.splitViewLayout?.layoutOrderPlanningOrders) {
                toolPanel = this.toolPanel.splitViewLayout.layoutOrderPlanningOrders.getToolsPanel();
            } else {
                return;
            }
            if (toolPanel.findNearOn())
                toolPanel.findNearAction.applyFindNear(false);
        }
    }

    async applyFindNear(findNearOn: boolean) {
        const table = this.toolPanel.table;
        this.findNearOn = findNearOn;
        const color = this.findNearOn ? this.findNearOnColor : "primary";
        this.getButton().color = color;
        this.toolPanel.actionsLayout.buttonActions.color = color;
        this.toolPanel.actionsLayout.buttonActions.color = color;
        if (this.toolPanel.splitViewLayout) {
            const promises = [this.applyFindNearToEquipLayout(this.toolPanel.splitViewLayout.layoutOrderPlanningEquipment)];
            if (this.toolPanel.splitViewLayout.layoutTimeline != null) {
                promises.push(this.applyFindNearToEquipLayout(this.toolPanel.splitViewLayout.layoutTimeline));
            }
            await Promise.all(promises);
            if (table.id === "tableAvailableMoves") {
                table.selectionMode = this.findNearOn ? SelectionMode.SINGLE : SelectionMode.MULTI;
            }
        }
    }

    private async applyFindNearToEquipLayout(layout: OrderPlanningEquipment | OrderPlanningTimeline) {
        const table = this.toolPanel.table;
        const layoutTable = layout["getTable"]();
        const columnDeadhead = layoutTable.getColumnByCaption("Deadhead");
        layoutTable.setColumnVisibility(columnDeadhead, this.findNearOn);
        if (this.findNearOn) {
            columnDeadhead.headingCell.getSortSelectorLabel().color = "success";
            columnDeadhead.headingCell.getSortSelectorLabel().style.fontWeight = "600";

            const fn_move_id = table?.selectedRow?.data.get("movement_id");
            const fn_orig_latitude = table?.selectedRow?.data.get("origin_latitude");
            const fn_orig_longitude = table?.selectedRow?.data.get("origin_longitude");
            const fn_orig_city = table?.selectedRow?.data.get("origin_city");
            const fn_orig_state = table?.selectedRow?.data.get("origin_state");
            const fn_orig_zip = table?.selectedRow?.data.get("origin_zip");

            layout["findNearProps"] = {
                fn_move_id,
                fn_orig_latitude,
                fn_orig_longitude,
                fn_orig_city,
                fn_orig_state,
                fn_orig_zip
            };
        } else {
            layout["findNearProps"] = null;
        }
        await layout.search();
        if (layout instanceof OrderPlanningTimeline) {
            layout.redisplay();
        }
    }
}
